import Resource from './Resource';

export default class ClassPageTopicLog extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
		} = options;

		let config = {
			route: 'class-pages/:courseSectionGuid/topic-activity-logs',
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	post() {
		return this.request("post");
	}
}
